import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getConfig } from '../../../config/portal';
import './styles.css';

class BrokerSpotlight extends PureComponent {
  render() {
    const { owner } = this.props;
    if (owner && owner.brokerSpotlight && owner.brokerSpotlightId && get(getConfig(), 'pages.details.brokerSpotlight')) {
      const src = `${get(getConfig(), 'pages.details.brokerSpotlight.endpoint', '')}?broker_id=${owner.brokerSpotlightId}&callsrc=${get(getConfig(), 'name')}`;
      return <iframe src={src} frameBorder="0" className="brokerspotlight-iframe"></iframe>;
    }
    return null;
  }
}

BrokerSpotlight.propTypes = {
  owner: PropTypes.object
};

export default BrokerSpotlight;
